import { PayloadAction } from "@reduxjs/toolkit";
import { put, take, takeLatest } from "redux-saga/effects";
import { signup, signin, success, failed, otpverification, successLogin, getoneuser } from '../slice/userSlice';
import { getRequest, postRequest, patchRequest } from "./ApiInstence";
import { toast } from "react-toastify";
import { addContectUs } from "../slice/contactusSlice";
import { getBanners, successBanners, failedBanners } from "../slice/bannerSlice";
import { getPackages, successPackage, failedPackage, getOnePackage, successOnePackage } from "../slice/khajurahoPackageSlice";
import { addEnquiry, successEnquiry, failedEnquiry } from "../slice/enquirySlice";
import { getVideos, successVideo, failedVideo } from "../slice/videoSlice";
import { getTestimonials, successTestimonial, failedTestimonial } from "../slice/testimonialSlice";
import { getVisits, successVisit, failedVisit, likeVisit } from "../slice/visitSlice";
import { getGalleries, successGallery, failedGallery } from "../slice/gallerySlice";
import { addBooking, successBooking, failedBooking } from "../slice/bookingSlice";
import { getServices, successService, failedService } from "../slice/serviceSlice";



import { postContactUsAPI } from "./contactus/contactUsApi";

function* signinUser({ payload }) {
  try {
    const response = yield postRequest('customer/login', payload);
    if (response?.status == 200) {
      yield put(successLogin(response));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    yield put(failed(error));
  }
}

function* getoneuserFun({ payload }) {
  try {
    const response = yield getRequest('customer/one/' + payload?.email);
    if (response?.status === 200) {
      yield put(success(response));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    yield put(failed(error));
  }
}

function* otpverification_fun({ payload }) {
  try {
    const response = yield postRequest('customer/otp', payload);
    if (response?.status === 200) {
      yield put(success(response));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    yield put(failed(error));
  }
}

function* signupUser({ payload }) {
  try {
    const response = yield postRequest('customer', payload);
    if (response?.status === 200) {
      yield put(success(response));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    console.log(error);
    toast(error.message);
  }
}

function* getBannersFun() {
  try {
    const response = yield getRequest('banner');
    if (response?.status === 200) {
      // Backend returns { success: true, data: [...] }
      yield put(successBanners(response?.data?.data));
    } else {
      yield put(failedBanners(response?.data?.message || "Failed to fetch banners"));
    }
  } catch (error) {
    console.error("Banner fetch error:", error);
    yield put(failedBanners(error.message));
  }
}

function* getPackagesFun() {
  try {
    const response = yield getRequest('packages');
    if (response?.status === 200) {
      yield put(successPackage(response?.data?.data));
    } else {
      yield put(failedPackage(response?.data?.message || "Failed to fetch packages"));
    }
  } catch (error) {
    console.error("Package fetch error:", error);
    yield put(failedPackage(error.message));
  }
}

function* getOnePackageFun({ payload }) {
  try {
    const response = yield getRequest(`packages/${payload}`);
    const itineraryRes = yield getRequest(`itineraries/${payload}`);
    
    if (response?.status === 200) {
      const packageData = response?.data?.data;
      if (itineraryRes?.status === 200) {
        packageData.itineraries = itineraryRes?.data?.data;
      }
      yield put(successOnePackage(packageData));
    } else {
      yield put(failedPackage(response?.data?.message || "Failed to fetch package"));
    }
  } catch (error) {
    console.error("Single package fetch error:", error);
    yield put(failedPackage(error.message));
  }
}

function* addEnquiryFun({ payload }) {
  try {
    const response = yield postRequest('enquiries', payload);
    if (response?.status === 201 || response?.status === 200) {
      yield put(successEnquiry());
      // toast.success("Enquiry sent successfully!");
    } else {
      yield put(failedEnquiry(response?.data?.message || "Failed to send enquiry"));
    }
  } catch (error) {
    console.error("Enquiry error:", error);
    yield put(failedEnquiry(error.message));
  }
}

function* getVideosFun() {
  try {
    const response = yield getRequest('videos');
    if (response?.status === 200) {
      yield put(successVideo(response?.data?.data));
    } else {
      yield put(failedVideo(response?.data?.message || "Failed to fetch videos"));
    }
  } catch (error) {
    yield put(failedVideo(error.message));
  }
}

function* getTestimonialsFun() {
  try {
    const response = yield getRequest('testimonial');
    if (response?.status === 200) {
      yield put(successTestimonial(response?.data?.data));
    } else {
      yield put(failedTestimonial(response?.data?.message || "Failed to fetch testimonials"));
    }
  } catch (error) {
    yield put(failedTestimonial(error.message));
  }
}

function* getVisitsFun() {
  try {
    const response = yield getRequest('visits');
    if (response?.status === 200) {
      yield put(successVisit(response?.data?.data));
    } else {
      yield put(failedVisit(response?.data?.message || "Failed to fetch visits"));
    }
  } catch (error) {
    yield put(failedVisit(error.message));
  }
}

function* likeVisitFun({ payload }) {
  try {
    const response = yield patchRequest(`visits/like/${payload}`);
    if (response?.status === 200) {
      yield getVisitsFun();
    }
  } catch (error) {
    console.error("Like error:", error);
  }
}

function* getGalleriesFun() {
  try {
    const response = yield getRequest('gallery');
    if (response?.status === 200) {
      yield put(successGallery(response?.data?.data));
    } else {
      yield put(failedGallery(response?.data?.message || "Failed to fetch gallery"));
    }
  } catch (error) {
    yield put(failedGallery(error.message));
  }
}

function* addBookingFun({ payload }) {
  try {
    const response = yield postRequest('bookings', payload);
    if (response?.status === 201 || response?.status === 200) {
      yield put(successBooking());
      // toast.success("Booking enquiry sent successfully!");
    } else {
      yield put(failedBooking(response?.data?.message || "Failed to send booking enquiry"));
    }
  } catch (error) {
    console.error("Booking error:", error);
    yield put(failedBooking(error.message));
  }
}

function* getServicesFun() {
  try {
    const response = yield getRequest('service');
    if (response?.status === 200) {
      yield put(successService(response?.data?.data));
    } else {
      yield put(failedService(response?.data?.message || "Failed to fetch services"));
    }
  } catch (error) {
    yield put(failedService(error.message));
  }
}

// Generator function
export function* watchGetUser() {
  yield takeLatest(signin, signinUser);
  yield takeLatest(signup, signupUser);
  yield takeLatest(otpverification, otpverification_fun);
  yield takeLatest(getoneuser, getoneuserFun);
  yield takeLatest(addContectUs, postContactUsAPI);
  yield takeLatest(getBanners, getBannersFun);
  yield takeLatest(getPackages, getPackagesFun);
  yield takeLatest(getOnePackage, getOnePackageFun);
  yield takeLatest(addEnquiry, addEnquiryFun);
  yield takeLatest(getVideos, getVideosFun);
  yield takeLatest(getTestimonials, getTestimonialsFun);
  yield takeLatest(getVisits, getVisitsFun);
  yield takeLatest(likeVisit, likeVisitFun);
  yield takeLatest(getGalleries, getGalleriesFun);
  yield takeLatest(addBooking, addBookingFun);
  yield takeLatest(getServices, getServicesFun);
}
